import { fetchData, postData, putData, patchData, deleteData } from "./apis";

const base = "/workflow";

// Modules registry
export const listModules = () => fetchData(`${base}/modules`);
export const getFieldOptions = (module) => fetchData(`${base}/field-options?module=${encodeURIComponent(module)}`);
export const listCustomActions = () => fetchData(`${base}/custom-actions`);

// Definitions
export const listWorkflowDefinitions = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchData(`${base}/definitions${qs ? `?${qs}` : ""}`);
};
export const getWorkflowDefinition = (id) => fetchData(`${base}/definitions/${id}`);
export const createWorkflowDefinition = (payload) => postData(`${base}/definitions`, payload);
export const updateWorkflowDefinition = (id, payload) => putData(`${base}/definitions/${id}`, payload);
export const deleteWorkflowDefinition = (id) => deleteData(`${base}/definitions/${id}`);

// Escalations
export const listEscalations = (workflow_id) =>
  fetchData(`${base}/escalations${workflow_id ? `?workflow_id=${workflow_id}` : ""}`);
export const createEscalation = (payload) => postData(`${base}/escalations`, payload);
export const updateEscalation = (id, payload) => putData(`${base}/escalations/${id}`, payload);
export const deleteEscalation = (id) => deleteData(`${base}/escalations/${id}`);

// Running instances dashboard
export const listRuns = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchData(`${base}/runs${qs ? `?${qs}` : ""}`);
};

// Instances + tasks
export const listInstances = (record_type, record_id) =>
  fetchData(`${base}/instances?record_type=${encodeURIComponent(record_type)}&record_id=${encodeURIComponent(record_id)}`);
export const listMyTasks = (status) =>
  fetchData(`${base}/tasks?assignee=me${status ? `&status=${status}` : ""}`);
// Tasks the signed-in user has decided on (approved / rejected).
export const listMyDecisions = (status = "Approved,Rejected") =>
  fetchData(`${base}/tasks?decided_by=me&status=${encodeURIComponent(status)}`);
export const approveTask = (id, remarks) => postData(`${base}/tasks/${id}/approve`, { remarks });
export const rejectTask = (id, remarks) => postData(`${base}/tasks/${id}/reject`, { remarks });
export const reassignTask = (id, user_id) => postData(`${base}/tasks/${id}/reassign`, { user_id });

// Comments
export const listComments = (record_type, record_id) =>
  fetchData(`${base}/comments?record_type=${encodeURIComponent(record_type)}&record_id=${encodeURIComponent(record_id)}`);
export const createComment = (payload) => postData(`${base}/comments`, payload);
export const deleteComment = (id) => deleteData(`${base}/comments/${id}`);

// Audit log
export const listAudit = (record_type, record_id) =>
  fetchData(`${base}/audit?record_type=${encodeURIComponent(record_type)}&record_id=${encodeURIComponent(record_id)}`);

// Notifications
export const listNotifications = (unreadOnly = false) =>
  fetchData(`${base}/notifications${unreadOnly ? "?unread=1" : ""}`);
export const markNotificationRead = (id) => postData(`${base}/notifications/${id}/read`, {});
export const markAllNotificationsRead = () => postData(`${base}/notifications/read-all`, {});

// Task Templates
export const listTaskTemplates = () => fetchData(`${base}/task-templates`);
export const createTaskTemplate = (payload) => postData(`${base}/task-templates`, payload);
export const updateTaskTemplate = (id, payload) => putData(`${base}/task-templates/${id}`, payload);
export const deleteTaskTemplate = (id) => deleteData(`${base}/task-templates/${id}`);

// Task progress (for Assign Task nodes — checklist tick-off + file list)
export const updateTaskProgress = (taskId, progress) =>
  patchData(`${base}/tasks/${taskId}/progress`, progress);
